import styled from "@emotion/styled";

export const TestimonialContainer = styled.div`
    text-align: end;
    border-radius: 20px;
    width: 100%;
    margin: 0px 0px 30px;
    display: flex
    flex-direction: column;
    justify-content: center;
    align-items:center;
    margin-top: 30px;
`;

export const ActiveTestimonial = styled.div`
    text-align: center;
    font-size:18px;
    background: white;
    color:black;
    min-height: 10rem;
    margin:auto;
    padding: 0px 20px;
    border-radius:10px;
    display: flex;
    align-items: center;
    justify-content: center;
    line-height: 36px;
`;
export const TestimonialSection = styled.div`
    padding: 20px;
`;


export const TestimonialDots = styled.button`
    display: flex;
    width: 100%;
    padding: 20px;
    justify-content: center;
    gap: 8px;
    background-color: transparent;
    border: none;
`;
export const Dots = styled.button`
    width: 10px;
    height: 10px;
    border-radius: 50%;
    background-color: #bbb;
    border: none;
    cursor: pointer;
    transition: all 0.3s ease;
    &.active {
        background-color: #163b5d;
        width: 12px;
        height: 12px;
    }
`;

export const TestimonialTitle = styled.h2`
    color: #163b5d;
    text-align: center;
    font-size:30px;
    margin-bottom: 30px;
`;

export const TestimonialSubTitle = styled.h3`
    text-align: center;
    font-size: 18px;
    line-height: 36px;
    color: black;
    width: fit-content;
    margin: auto;
    padding: 10px;
    border-bottom: 2px solid #163b5d;
`;


export const TestimonialSectionSpan = styled.span`
    font-size: 50px;
    margin: 10px;
    svg{
        color: #173b5e;
    }
`;